var map = {
	"./apple-lift": [
		"./src/js/components/Animation/animations/apple-lift.json",
		"apple-lift"
	],
	"./apple-lift.json": [
		"./src/js/components/Animation/animations/apple-lift.json",
		"apple-lift"
	],
	"./broccoli-dance": [
		"./src/js/components/Animation/animations/broccoli-dance.json",
		"broccoli-dance"
	],
	"./broccoli-dance.json": [
		"./src/js/components/Animation/animations/broccoli-dance.json",
		"broccoli-dance"
	],
	"./exercises": [
		"./src/js/components/Animation/animations/exercises.json",
		"exercises"
	],
	"./exercises.json": [
		"./src/js/components/Animation/animations/exercises.json",
		"exercises"
	],
	"./salad": [
		"./src/js/components/Animation/animations/salad.json",
		"salad"
	],
	"./salad.json": [
		"./src/js/components/Animation/animations/salad.json",
		"salad"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/js/components/Animation/animations lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;